import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../../api";
import StickyNavSection from "./StickyNavSection";
import NotFound from "../../Pages/NotFound/NotFound";

const ProgramsDetails = () => {
  const { miniSlug, collegeSlug, programSlug } = useParams();
  const [programData, setProgramData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);

  const addCheckIconToList = (html) => {
    if (!html) return html;

    return html.replace(
      /<li>/g,
      '<li><i class="fa fa-check-circle-o me-2 "></i>',
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${process.env.REACT_APP_API_URL}/api/${miniSlug}/${collegeSlug}/programs/${programSlug}`;
        const response = await api.get(url);
        setProgramData(response.data);
        setLoading(false);
      } catch (err) {
        console.error("API Error:", err);
        setError(err.message);
        setLoading(false);
        setNotFound(true);
      }
    };
    fetchData();
  }, [miniSlug, collegeSlug, programSlug]);

  useEffect(() => {
    document.body.classList.add("hide-program-header");

    return () => {
      document.body.classList.remove("hide-program-header");
    };
  }, []);

  if (loading) return null;
  if (notFound) return <NotFound />;
  if (error) return null;
  if (!programData) return null;

  return (
    <main>
      {/* Hero Banner Section */}
      <section className="courses-details-section pt_80">
        <div
          className="inner-heros-warp"
          style={{
            backgroundImage: `url(${process.env.REACT_APP_API_URL}/public${programData.hero_image})`,
          }}
        >
          <div className="container">
            <div className="inner-hero-content row">
              <div className="col-md-6 col-12 text-start">
                <h3 className="theme-heading-without-after text-white text-start">
                  {programData.title}
                </h3>
              </div>
              <div className="col-md-6 col-12 text-start text-md-end">
                <img
                  src="/assets/images/care-logo-white.png"
                  alt="care-logo-white"
                  style={{ width: "200px" }}
                />
              </div>
            </div>
          </div>
          <div className="all-shapes">
            <img
              src="/assets/images/inner-page-shape1.png"
              className="inner-page-shape1"
              alt="shapes"
            />
          </div>
        </div>
      </section>
      <StickyNavSection />
      {/* Overview Section */}
      <section>
        <div className="container">
          <div className="row">
            <div className="text-column col-lg-12 col-md-12 col-sm-12 position-relative">
              <div className="inner-column">
                <div className="sec-title text-center">
                  <h2>Course Overview</h2>
                </div>

                {/* Render overview content - handle both plain text and HTML */}
                {programData.overview?.includes("<") ? (
                  <div
                    className="school-college-list"
                    dangerouslySetInnerHTML={{
                      __html: addCheckIconToList(programData.overview),
                    }}
                  />
                ) : (
                  programData.overview
                    ?.split("\n")
                    .map((paragraph, i) => <p key={i}>{paragraph}</p>)
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Learning Outcomes Section */}
      {programData.outcomes && programData.outcomes.length > 0 && (
        <section className="course-outcomes-section">
          <div className="container">
            {" "}
            <div className="sec-title py-3 text-center ">
              <h2>Course outcomes</h2>
            </div>
            <p className="mb-4">
              On completion of {programData.title} program, the graduates will
              be able to:
            </p>
            <div className="row row-cols-1 row-cols-md-2 g-4">
              {programData.outcomes.map((outcome, i) => (
                <div key={i} className="d-flex align-items-baseline">
                  <div className="check-icon me-2">
                    <i className="fa fa-check"></i>
                  </div>
                  <div>{outcome}</div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Syllabus Section */}
      {programData.syllabus?.years && programData.syllabus.years.length > 0 && (
        <section className="course-outcomes-section ">
          <div className="container">
            <div className="sec-title py-3">
              <h2>Syllabus</h2>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="faq-wrap pt-30 ">
                  <div className="accordion" id="syllabusAccordion">
                    {programData.syllabus.years.map((year, index) => (
                      <div key={index} className="card">
                        <div className="card-header" id={`heading${index}`}>
                          <h2 className="mb-0">
                            <button
                              className={`faq-btn ${index === 0 ? "" : "collapsed"}`}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse${index}`}
                            >
                              {year.name || `Year ${index + 1}`}
                            </button>
                          </h2>
                        </div>

                        <div
                          id={`collapse${index}`}
                          className={`collapse ${index === 0 ? "show" : ""}`}
                          data-bs-parent="#syllabusAccordion"
                        >
                          <div className="row p-3 gap-3">
                            {/* === CORE SUBJECTS OR PDFs === */}
                            {((year.core_subjects &&
                              year.core_subjects.length > 0) ||
                              (year.core_pdfs &&
                                year.core_pdfs.length > 0)) && (
                                <div className="card-body custom-card mb-4 col-md-4">
                                  <p className="theme-heading text-start">
                                    {year.label_core_subjects || "Core Subjects"}:
                                  </p>

                                  {/* Core Subjects */}
                                  {year.core_subjects &&
                                    year.core_subjects.length > 0 && (
                                      <div className="mb-3">
                                        {year.core_subjects.map((subject, i) => (
                                          <div
                                            key={i}
                                            className="d-flex align-items-baseline"
                                          >
                                            <div className="check-icon me-2">
                                              <i className="fa fa-check"></i>
                                            </div>
                                            <div>{subject}</div>
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                  {/* Core PDFs with Titles */}
                                  {year.core_pdfs &&
                                    year.core_pdfs.length > 0 && (
                                      <div className="mt-3">
                                        <p className="fw-bold mb-0">
                                          Download{" "}
                                          {year.label_core_subjects ||
                                            "Core Subjects"}{" "}
                                          Syllabus
                                        </p>
                                        <ul className="list-unstyled">
                                          {year.core_pdfs.map((pdf, i) => (
                                            <li key={i}>
                                              <a
                                                href={`${process.env.REACT_APP_API_URL}/public${pdf.path}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-primary text-decoration-underline"
                                              >
                                                {pdf.title ||
                                                  `Core File ${i + 1}`}
                                              </a>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
                                </div>
                              )}

                            {/* === SKILL DEVELOPMENT OR PDFs === */}
                            {((year.skill_development &&
                              year.skill_development.length > 0) ||
                              (year.skill_pdfs &&
                                year.skill_pdfs.length > 0)) && (
                                <div className="card-body custom-card mb-4 col-md-4">
                                  <p className="theme-heading text-start">
                                    {year.label_skill_development ||
                                      "Skill Development & Enrichment"}
                                    :
                                  </p>

                                  {/* Skills */}
                                  {year.skill_development &&
                                    year.skill_development.length > 0 && (
                                      <div className="mb-3">
                                        {year.skill_development.map(
                                          (skill, i) => (
                                            <div
                                              key={i}
                                              className="d-flex align-items-baseline"
                                            >
                                              <div className="check-icon me-2">
                                                <i className="fa fa-check"></i>
                                              </div>
                                              <div>{skill}</div>
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    )}

                                  {/* Skill PDFs */}
                                  {year.skill_pdfs &&
                                    year.skill_pdfs.length > 0 && (
                                      <div className="mt-3">
                                        <p className="fw-bold mb-0">
                                          Download{" "}
                                          {year.label_skill_development ||
                                            "Skill Development & Enrichment"}{" "}
                                          Syllabus
                                        </p>
                                        <ul className="list-unstyled">
                                          {year.skill_pdfs.map((pdf, i) => (
                                            <li key={i}>
                                              <a
                                                href={`${process.env.REACT_APP_API_URL}/public${pdf.path}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-primary text-decoration-underline"
                                              >
                                                {pdf.title ||
                                                  `Skill File ${i + 1}`}
                                              </a>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
                                </div>
                              )}

                            {/* === VALUE-ADDED OR PDFs === */}
                            {((year.value_added &&
                              year.value_added.length > 0) ||
                              (year.value_added_pdfs &&
                                year.value_added_pdfs.length > 0)) && (
                                <div className="card-body custom-card mb-4 col-md-4">
                                  <p className="theme-heading text-start">
                                    {year.label_value_added ||
                                      "Value-Added Courses"}
                                    :
                                  </p>

                                  {/* Value-Added Courses */}
                                  {year.value_added &&
                                    year.value_added.length > 0 && (
                                      <div className="mb-3">
                                        {year.value_added.map((course, i) => (
                                          <div
                                            key={i}
                                            className="d-flex align-items-baseline"
                                          >
                                            <div className="check-icon me-2">
                                              <i className="fa fa-check"></i>
                                            </div>
                                            <div>{course}</div>
                                          </div>
                                        ))}
                                      </div>
                                    )}

                                  {/* Value PDFs with Titles */}
                                  {year.value_added_pdfs &&
                                    year.value_added_pdfs.length > 0 && (
                                      <div className="mt-3">
                                        <p className="fw-bold mb-0">
                                          Download{" "}
                                          {year.label_value_added ||
                                            "Value-Added Courses"}{" "}
                                          Syllabus
                                        </p>
                                        <ul className="list-unstyled">
                                          {year.value_added_pdfs.map((pdf, i) => (
                                            <li key={i}>
                                              <a
                                                href={`${process.env.REACT_APP_API_URL}/public${pdf.path}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-primary text-decoration-underline"
                                              >
                                                {pdf.title ||
                                                  `Value File ${i + 1}`}
                                              </a>
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Eligibility Section - Updated to show all sections */}
      {programData.eligibility?.sections && programData.eligibility.sections.length > 0 && (
        <section className="course-outcomes-section">
          <div className="container">
            {programData.eligibility.sections.map((section, i) => (
              <div key={i} className="mb-5">
                <div className="sec-title py-3">
                  <h2>{section.title}</h2>
                </div>
                <div className="mb-3">
                  {section.content && (
                    section.content.includes("<") ? (
                      <div
                        className="school-college-list"
                        dangerouslySetInnerHTML={{
                          __html: addCheckIconToList(section.content),
                        }}
                      />
                    ) : (
                      <p>{section.content}</p>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
      {/* Admissions Section */}
      {programData.admission_link && (
        <section className="admission_section py-5 mt-lg-5">
          <div className="container">
            <div className="admission-wrapper">
              <h1 className="admission-title">Admissions</h1>
              <a
                className="admission-btn"
                href={programData.admission_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                Apply Now
              </a>
            </div>
          </div>
        </section>
      )}
    </main>
  );
};

export default ProgramsDetails;
